<app-preloader></app-preloader>
<app-header></app-header>
<app-breadcrumbs></app-breadcrumbs>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<footer class="sigma_footer footer-2 sigma_footer-dark">
    <app-footer></app-footer>
</footer>

<div *ngIf="showCookieConsentBanner" class="cookie-consent-banner">
    <div class="cookie-message d-flex align-items-center justify-content-around">
        <div class="row">
            <div class="col-lg-7 col-md-6 text-start">
                <p class="mb-0"> {{'cookies_message' | translate}} </p>
            </div>
            <div class="col-lg-5 col-md-6 text-end buttons-container">
                <button class="accept" (click)="acceptCookies()">{{'accept' | translate}}</button>
                <button class="reject" (click)="declineCookies()">{{'reject' | translate}}</button>
            </div>
        </div>
    </div>
</div>

<div class="audio-player-fixed" [class.show]="showBottomAudio">
    <span (click)="onAudioClose()" class="close-audio">X {{'close_audio' | translate}}</span>
    <div (click)="redirectToAudioDetails()" class="audio-title">{{audioTitle}}</div>
    <div class="audio-wrapper" id="bottom-player-container" [class.show]="showBottomAudio">
        <div plyr 
            #bottomPlayer 
            [plyrType]="'audio'" 
            [plyrPlaysInline]="true" 
            [plyrSources]="audioUrl"
            (plyrPlay)="onAudioPlay()"
            (plyrPause)="onAudioPause()"
            (plyrTimeUpdate)="onTimeUpdate($event)"
            >
        </div>
        <span class="bottom-audio-time">{{ audioTime }} </span>
    </div>
</div>